const getSetting = (state) => {
    return state.setting
}

export {
    getSetting,
};